import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MfaService } from '../mfa-service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-mfa-setup',
  templateUrl: './mfa-setup.component.html',
  styleUrls: ['./mfa-setup.component.scss']
})
export class MfaSetupComponent implements OnInit {
  countdown = 5;
  step = 1;
  qrCodeData = '';
  secretKey = '';
  errors: string[] = [];
  error: string = '';
  environmentName = environment.environmentName;
  intervalId: any;
  boxes = [0, 1, 2, 3, 4, 5];
  isVerifying = false;
  mfaCode: string = '';
  verifyError: string = '';
  recoveryCodes: string[];

  constructor(private mfaService: MfaService, private router: Router, private _translateService: TranslateService) { }

  ngOnInit() {
    const mfaSessionId = sessionStorage.getItem('mfaSessionId');
    if (!mfaSessionId) {
      this.backToLogin();
    }

    this.mfaService.enableMfa(mfaSessionId!).subscribe({
      next: (response: any) => {
        this.qrCodeData = response.qrCodeData;
        this.secretKey = response.key;
      },
      error: () => {
        this.errors[0] = this._translateService.instant('MFA.SETUP.FOUTMELDING');
      }
    });
  }

  goToStepTwo() {
    this.step = 2;
    setTimeout(() => {
      const el = document.getElementById("mfa-0") as HTMLInputElement;
      el?.focus();
    }, 0);
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.intervalId);
        this.backToLogin();
      }
    }, 1000);
  }

  backToLogin() {
    this.router.navigate(['auth', 'login']);
  }

  verifySetup() {
    const mfaSessionId = sessionStorage.getItem('mfaSessionId');
    this.errors = [];
    this.mfaService.verifySetup(this.mfaCode, mfaSessionId!).subscribe({
      next: (response) => {
        if (response.success) {
          //this.startCountdown();
          this.step = 3;
          this.verifyError = '';
          this.recoveryCodes = response.recoveryCodes;
          sessionStorage.removeItem('mfaSessionId');
        } else {
          this.verifyError = this._translateService.instant('MFA.SETUP.ONGELDIGE_CODE');
          this.mfaCode = '';
          this.boxes.forEach((i) => {
            const box = document.getElementById(`mfa-${i}`) as HTMLInputElement;
            if (box) box.value = '';
          });
          setTimeout(() => {
            const el = document.getElementById("mfa-0") as HTMLInputElement;
            el?.focus();
          }, 0);
        }
      },
      error: () => {
        this.errors[0] = this._translateService.instant('MFA.SETUP.FOUTMELDING');
      }
    });
  }

  onInput(event: any, index: number) {
    const input = event.target;
    const value = input.value.replace(/[^0-9]/g, "");
    input.value = value;

    if (value && index < 5) {
      // volgende vakje focussen
      const next = document.getElementById(`mfa-${index + 1}`) as HTMLInputElement;
      next?.focus();
    }

    this.updateCode();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === "Backspace" && !input.value && index > 0) {
      const prev = document.getElementById(`mfa-${index - 1}`) as HTMLInputElement;
      prev?.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('text') ?? "";
    const digits = paste.replace(/\D/g, "").slice(0, 6);

    digits.split("").forEach((d, i) => {
      const box = document.getElementById(`mfa-${i}`) as HTMLInputElement;
      if (box) box.value = d;
    });

    this.updateCode();

    event.preventDefault();
  }

  updateCode() {
    const values = this.boxes
      .map(i => (document.getElementById(`mfa-${i}`) as HTMLInputElement)?.value ?? "");

    this.mfaCode = values.join("");

    // Als alle 6 cijfers zijn ingevuld → automatisch valideren
    if (this.mfaCode.length === 6 && /^[0-9]{6}$/.test(this.mfaCode)) {
      this.verifySetup();
    }
  }
}



